import axios from "axios";
import config from "@/config";
import { getToken } from "@/libs/util";
const baseUrl =
  process.env.NODE_ENV === "development"
    ? config.baseUrl.dev
    : config.baseUrl.pro;
var directorystranges={
    queryDirectoryByFilter:'/sys/directory/queryDirectoryByFilter/',
    queryProjectList:"/sys/directory/queryProjectList/",
    newDirectory:'/sys/directory/newDirectory/',
    updateDirectoryById:'/sys/directory/updateDirectoryById/',
    deleteDirectoryById:'/sys/directory/deleteDirectoryById/',
    queryDirectoryById:'/sys/directory/queryDirectoryById/',
    fuzzyQueryDirectoryList:'/sys/directory/fuzzyQueryDirectoryList'
}
export default function(method,apiname,params,path){
   
    if(!path)path='';
    let  data=params;
    if(apiname=='newDirectory'){
        data={
            ...params,
        }
    }
    return axios.request({
        method:method,
        url:baseUrl+directorystranges[apiname]+path,
        headers:{
            // token:localStorage['token'],
            token:getToken(),
            "Content-Type": "application/json;"  
        },
        data:data
    })
}